import { render, staticRenderFns } from "./OverdueOmbudsman.vue?vue&type=template&id=ba48f90a&scoped=true&"
import script from "./OverdueOmbudsman.vue?vue&type=script&lang=js&"
export * from "./OverdueOmbudsman.vue?vue&type=script&lang=js&"
import style0 from "./OverdueOmbudsman.vue?vue&type=style&index=0&id=ba48f90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba48f90a",
  null
  
)

export default component.exports